import { __assign, __rest } from "tslib";
import * as React from 'react';
import MaskedInput from 'react-text-mask';
export var DateMaskedInput = function (props) {
    var inputRef = props.inputRef, other = __rest(props, ["inputRef"]);
    return (React.createElement(MaskedInput, __assign({}, other, { ref: function (ref) { return inputRef(ref ? ref.inputElement : null); }, mask: [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/] })));
};
